import Tippy from "@tippyjs/react";
import { P, R } from "apparatus/library/common";
import { RotationHandler } from "editing/rotation/rotation_handler";
import { t } from "i18next";
import * as React from "react";
import { Trans } from "react-i18next";
import { Debug } from "vars";
import { CtrlKey, Key } from "view/keyboard_shortucts";
import { Nl } from "view/tooltips";
/**
 * Component to display a rectangle around the current selection
 * plus an icon that can be clicked on to perform rotation.
 * To use this component, instantiate it and update by setting state.
 */
export class SelectionOverlay extends React.Component {
    constructor(props) {
        super(props);
        /** Ref to the rotation handle. */
        this.rotatioHandleRef = React.createRef();
        /** Helper for handling updating items when the rotation handler is used */
        this.rotationHandler = new RotationHandler();
        this.state = { isVisible: false, center: P(0, 0), bounds: R(0, 0, 0, 0) };
    }
    componentDidMount() {
        this.setUpRotationHandler();
    }
    render() {
        let { isVisible, center, bounds } = this.state;
        let shouldHide = this.props.hideDueToInteraction;
        let presentationModeStyles = Debug.PRESENTATION_MODE ? { opacity: 0.0 } : {};
        return React.createElement("div", { id: "selection-center", key: "selectionCenter", style: {
                visibility: isVisible && !shouldHide ? "visible" : "hidden",
                left: center.x,
                top: center.y
            } },
            React.createElement("div", { id: "selection-box", key: "box", style: Object.assign({ left: bounds.x - center.x - 5, top: bounds.y - center.y - 5, width: bounds.width + 10, height: bounds.height + 10 }, presentationModeStyles) }),
            React.createElement(Tippy, { content: React.createElement(RotationHint, null), delay: [1000, 0] },
                React.createElement("div", { id: "rotation-handle", key: "handle_image", ref: this.rotatioHandleRef, style: Object.assign({ top: bounds.y - center.y - 60 }, presentationModeStyles) },
                    React.createElement("i", { className: "fas fa-sync-alt" }))));
    }
    /** Sets up the rotation handle to be draggable, using jQuery. */
    setUpRotationHandler() {
        let handle = $(this.rotatioHandleRef.current);
        let self = this;
        handle.draggable({
            revert: true,
            revertDuration: 0,
            cursorAt: { top: 14, left: 0 }, // 14 is derived from the size of the rotation handler. See LESS files.
            start: function (e, ui) {
                let rotationType = self.rotationHandler.onStart();
                self.props.onStartRotation(rotationType);
            },
            drag: function (e, ui) {
                var pos = $(this).position();
                // How many snap points?
                var snaps = 72;
                if (e.ctrlKey) {
                    snaps = 360;
                }
                else if (e.shiftKey) {
                    snaps = 16;
                }
                else if (e.altKey) {
                    snaps = 0;
                }
                let angle = self.rotationHandler.onRotate(pos.left, pos.top, snaps);
                self.props.onUpdateRotation(angle);
            },
            stop: function (e, ui) {
                self.rotationHandler.onEnd();
                self.props.onEndRotation();
            }
        }).on('click', function () {
            toastr.info(t("info.rotate_popup"));
        });
    }
}
const RotationHint = () => React.createElement(React.Fragment, null,
    t("info.rotation.hint.title"),
    React.createElement("div", { className: "shortcut" },
        React.createElement(Nl, null,
            React.createElement(Trans, { i18nKey: "info.rotation.hint.description" },
                "By default, rotates in 5\u00B0 steps. Hold ",
                React.createElement(CtrlKey, null),
                " for 1\u00B0 steps Hold ",
                React.createElement(Key, { k: "Shift" }),
                " for 22.5\u00B0 steps Hold ",
                React.createElement(Key, { k: "Alt" }),
                " for free rotation"))));
